import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "projects/ert/src/environments/environment";
import { Ikr998Data } from "../../interfaces/ert-kr998/ert-kr998Data";
import { Observable } from "rxjs";
import { FormGroup } from "@angular/forms";
import { IPicklistValuesData } from "../../interfaces/administration/picklistValuesData";
import { PicklistService } from "../administration/picklist/picklist.service";
import { TrainingType } from "../../services/administration/trainingtypes/trainingtypes";
import { DatePipe } from "@angular/common";
const apiUrl = environment.apiUrl + "/kr998";

@Injectable({
  providedIn: "root",
})
export class Kr998Service {
  kr998: Ikr998Data;
  printType: string;
  kr998Id: number;
  users: any[] = [];
  instructors: any[] = [];
  crewFieldId: number = 0;
  categoryFieldId: number = 0;
  unitFieldId: number = 0;
  instructorName: string;
  filteredInstructors: any[] = [];

  constructor(
    private http: HttpClient,
    private pickListsService: PicklistService
  ) {}

  getAllKr998(facilityId : number): Observable<Ikr998Data[]> {
    return this.http.get<Ikr998Data[]>(`${apiUrl}/facility/${facilityId}`);
  }

  getKr998(id: number, facilityId: number): Observable<Ikr998Data> {
    return this.http.get<Ikr998Data>(`${apiUrl}/${id}?loggedInUserFacilityId=${facilityId}`);
  }

  createKr998(data: Ikr998Data): Observable<Ikr998Data> {
    return this.http.post<Ikr998Data>(apiUrl, data);
  }

  editKr998(kr: Ikr998Data, facilityId: number): Observable<Ikr998Data> {
    return this.http.put<Ikr998Data>(`${apiUrl}/${kr.id}?loggedInUserFacilityId=${facilityId}`, kr);
  }

  deleteKr998(id: number, facilityId: number): Observable<boolean> {
    return this.http.delete<boolean>(`${apiUrl}/${id}?loggedInUserFacilityId=${facilityId}`);
  }
  public validate(form: FormGroup<any>): string[] {
    const errors: string[] = [];
    if (!form.get("instructor")?.value) {
      errors.push("Instructor is required");
    }
    if (!form.get("company")?.value) {
      errors.push("Company is required");
    }
    if (!form.get("location")?.value) {
      errors.push("Location is required");
    }
    if (!form.get("trainingType")?.value) {
      errors.push("Training Type is required");
    }
    if (!form.get("startDate")?.value || !form.get("startTime")?.value) {
      errors.push("Start Date and Time are required");
    }
    if (!form.get("endDate")?.value || !form.get("endTime")?.value) {
      errors.push("End Date and Time are required");
    }
    if (!form.get("description")?.value) {
      errors.push("Training class description is required");
    }
    if (!form.get("hours")?.value) {
      errors.push("Training class hours is required");
    }
    if (form.get("category")?.value === "-1") {
      errors.push("Category is required");
    }
    if (form.get("crew")?.value === "-1") {
      errors.push("Crew is required");
    }
    return errors;
  }

  public validateEdit(form: FormGroup): string[] {
    const errors: string[] = [];
    if (!form.get("instructor")?.value) {
      errors.push("Instructor is required");
    }
    if (!form.get("facilityId")?.value) {
      errors.push("Facility is required");
    }
    return errors;
  }

  public validateView(form: FormGroup): string[] {
    const errors: string[] = [];
    if (!form.get("instructor")?.value) {
      errors.push("Instructor is required");
    }
    if (form.get("category")?.value === "-1") {
      errors.push("Category is required");
    }
    if (form.get("crew")?.value === "-1") {
      errors.push("Crew is required");
    }
    if (!form.get("startDateTime")?.value) {
      errors.push("Start date is required");
    }
    if (!form.get("endDateTime")?.value) {
      errors.push("End date is required");
    }
    return errors;
  }

  public getValueForField(
    picklistValues: IPicklistValuesData[],
    fieldId: number
  ) {
    let name = "";
    if (picklistValues) {
      const fieldValue = picklistValues.find(
        (x) => x.picklistFieldId === fieldId
      );
      if (fieldValue) {
        name = fieldValue.value?.toString();
      }
    }
    return name;
  }

  formatDate(input: string): string {
    const date = new Date(input);

    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");

    let hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const ampm = Number(hours) >= 12 ? "PM" : "AM";
    hours = (Number(hours) % 12).toString().padStart(2, "0");
    hours = Number(hours) ? hours : "12";
    const strTime = `${hours}:${minutes} ${ampm}`;

    return `${month}/${day}/${year} ${strTime}`;
  }

  public printKR998(printType: string, kr998Id: number, facilityId: number): void {
    this.pickListsService.getFieldIdByName("Crew").subscribe((crewFieldId) => {
      if (crewFieldId) {
        this.crewFieldId = crewFieldId;
      }
    });
    this.pickListsService
      .getFieldIdByName("Category KR998")
      .subscribe((categoryFieldId) => {
        if (categoryFieldId) {
          this.categoryFieldId = categoryFieldId;
        }
      });
    this.pickListsService.getFieldIdByName("Units").subscribe((unitFieldId) => {
      if (unitFieldId) {
        this.unitFieldId = unitFieldId;
      }
    });

    if (printType !== "blank") {
      this.getKr998(kr998Id, facilityId).subscribe({
        next: (data) => {
          this.kr998 = data;
          this.kr998.startDateTime = this.formatDate(
            data.startDateTime.slice(0, 16)
          );
          this.kr998.endDateTime = this.formatDate(
            data.endDateTime.slice(0, 16)
          );
          this.users = data.kr998ErtUsers.filter((user) => !user.isInstructior);
          this.instructors = data.kr998ErtUsers.filter(
            (user) => user.isInstructior
          );
          this.filteredInstructors = this.instructors
            .filter((user) => user.kr998Id === kr998Id && user.createdDate)
            .sort(
              (a, b) =>
                new Date(a.createdDate).getTime() -
                new Date(b.createdDate).getTime()
            );
          this.instructorName =
            this.filteredInstructors.length > 0
              ? this.filteredInstructors[0].userErt.fullName
              : "";
          if (printType === "attendedOnly") {
            this.users = this.users.filter((x) => x.attendanceStatus === 1);
            this.instructors = this.instructors.filter(
              (x) => x.attendanceStatus === 1
            );
          }
          this.printKR998Window(printType);
        },
        error: (error) => {
          console.error("Error getting kr998 data: ", error);
        },
      });
    } else {
      this.users = [];
      this.instructors = [];
      this.kr998 = null;
      this.instructorName = "";

      this.printKR998Window(printType);
    }
  }

  printKR998Window(printType: string): void {
    let offsetUserRows = "";
    let offsetInstructorRows = "";
    const printWindow = window.open("", "_blank");

    if (printWindow) {
      if (5 - this.users.length > 0) {
        offsetUserRows = Array(5 - this.users.length)
          .fill(
            `
          <tr>
            <td style="border: 1px solid #000; padding: 2px;"></td>
            <td style="border: 1px solid #000; padding: 2px;"></td>
            <td style="border: 1px solid #000; padding: 2px;"></td>
            <td style="border: 1px solid #000; padding: 2px;">&nbsp;</td>
            <td style="border: 1px solid #000; padding: 2px;">&nbsp;</td>
          </tr>
        `
          )
          .join("");
      }
      // Generate the rows for users
      let userRows = this.users
        .map(
          (user) => `
            <tr>
              <td style="border: 1px solid #000; padding: 2px;">${
                user.userErt.caiEmail ?? ""
              }</td>
              <td style="border: 1px solid #000; padding: 2px;">${
                user.userErt.fullName ?? ""
              }</td>
              <td style="border: 1px solid #000; padding: 2px;">${
                user.userErt.mgcccNumber ?? ""
              }</td>
              <td style="border: 1px solid #000; padding: 2px;">&nbsp;</td>
              <td style="border: 1px solid #000; padding: 2px;">${this.getLastPostedUnit(
                user.userErt?.picklistValues
              )}</td>
            </tr>
          `
        )
        .join("");
      userRows += offsetUserRows;
      userRows += `<tr>
            <td style="border: 1px solid #000; padding: 2px;"></td>
            <td style="border: 1px solid #000; padding: 2px;"></td>
            <td style="border: 1px solid #000; padding: 2px;"></td>
            <td style="border: 1px solid #000; padding: 2px;">&nbsp;</td>
            <td style="border: 1px solid #000; padding: 2px;">&nbsp;</td>
          </tr>
          <tr>
            <td style="border: 1px solid #000; padding: 2px;"></td>
            <td style="border: 1px solid #000; padding: 2px;"></td>
            <td style="border: 1px solid #000; padding: 2px;"></td>
            <td style="border: 1px solid #000; padding: 2px;">&nbsp;</td>
            <td style="border: 1px solid #000; padding: 2px;">&nbsp;</td>
          </tr>
          <tr>
            <td style="border: 1px solid #000; padding: 2px;"></td>
            <td style="border: 1px solid #000; padding: 2px;"></td>
            <td style="border: 1px solid #000; padding: 2px;"></td>
            <td style="border: 1px solid #000; padding: 2px;">&nbsp;</td>
            <td style="border: 1px solid #000; padding: 2px;">&nbsp;</td>
          </tr>
          `;

      if (5 - this.instructors.length > 0) {
        offsetInstructorRows = Array(5 - this.instructors.length)
          .fill(
            `
            <tr>
              <td style="border: 1px solid #000; padding: 2px;"></td>
              <td style="border: 1px solid #000; padding: 2px;"></td>
              <td style="border: 1px solid #000; padding: 2px;"></td>
              <td style="border: 1px solid #000; padding: 2px;">&nbsp;</td>
              <td style="border: 1px solid #000; padding: 2px;">&nbsp;</td>
            </tr>
          `
          )
          .join("");
      }
      // Generate the rows for instructors
      let instructorRows = this.instructors
        .map(
          (instructor) => `
            <tr>
              <td style="border: 1px solid #000; padding: 2px;">${
                instructor.userErt.caiEmail ?? ""
              }</td>
              <td style="border: 1px solid #000; padding: 2px;">${
                instructor.userErt.fullName ?? ""
              }</td>
              <td style="border: 1px solid #000; padding: 2px;">${
                instructor.userErt.mgcccNumber ?? ""
              }</td>
              <td style="border: 1px solid #000; padding: 2px;"></td>
              <td style="border: 1px solid #000; padding: 2px;">${this.getLastPostedUnit(
                instructor.userErt?.picklistValues
              )}</td>
            </tr>
          `
        )
        .join("");
      instructorRows += offsetInstructorRows;

      // Define document content with inline styles
      printWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title style="text-align: center">KR998 - ${printType}</title>
        <meta charset="utf-8">
      </head>
      <body style="font-family: Arial, sans-serif; font-size: 12px; padding: 20px; margin: 0;">
        <main>
          <div style="padding: 20px; background-color: #fff;">
            <h2 style="text-align: center;">KR-998 ATTENDANCE LOG</h2>
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
              <tr>
                <td style="font-weight: bold; width: 15%; padding: 4px;">INSTRUCTOR</td>
                <td style="width: 35%; border: 1px solid #000; padding: 4px;">${
                  this.instructorName ?? ""
                }</td>
                <td style="width: 5%; padding: 4px;"></td>
                <td style="font-weight: bold; width: 15%; padding: 4px;">CREW</td>
                <td style="width: 35%; border: 1px solid #000; padding: 4px;">${this.getLastPostedCrew(
                  this.kr998?.picklistValues
                )}</td>
              </tr>
              <tr>
                <td style="font-weight: bold; padding: 4px;">COMPANY</td>
                <td style="border: 1px solid #000; padding: 4px;">${
                  this.kr998?.company ?? ""
                }</td>
                <td style="width: 5%; padding: 4px;"></td>
                <td style="font-weight: bold; padding: 4px;">LOCATION</td>
                <td style="border: 1px solid #000; padding: 8px;">${
                  this.kr998?.location ?? ""
                }</td>
              </tr>
              <tr>
                <td style="font-weight: bold; padding: 4px;">TRAINING TYPE</td>
                <td style="border: 1px solid #000; padding: 4px;">${
                  this.getTrainingTypeName(this.kr998?.trainingType) ?? ""
                }</td>
                <td style="width: 5%; padding: 8px;"></td>
              </tr>
              <tr>
                <td style="font-weight: bold; padding: 4px; white-space: nowrap;">Start Date and Time</td>
                <td style="border: 1px solid #000; padding: 4px;">${
                  this.kr998?.startDateTime ?? ""
                }</td>
                <td style="width: 5%; padding: 4px;"></td>
                <td style="font-weight: bold; padding: 4px; white-space: nowrap;">End Date and Time</td>
                <td style="border: 1px solid #000; padding: 4px;">${
                  this.kr998?.endDateTime ?? ""
                }</td>
              </tr>
            </table>
            <div style="padding: 10px; text-align: center; background-color: grey;">
              Please Note: Do not put "Safety Meeting" - Be Specific <br />
              If more than one specific subject is covered in one meeting, please create an additional entry.
            </div>
            <table style="width: 100%; border-collapse: collapse; margin-top: 20px;">
              <tr style="background-color: #e9ecef; text-align: center;">
                <td colspan="8" style="border: 1px solid #000; padding: 8px;">INSTRUCTION TITLE AND COMMENTS</td>
                <td style="border: 1px solid #000; padding: 8px;">HOURS</td>
              </tr>
              <tr>
                <td colspan="4" style="border: 1px solid #000; width: 50%; padding: 8px;">${this.getLastPostedCategory(
                  this.kr998?.picklistValues
                )}</td>
                <td colspan="4" style="border: 1px solid #000; width: 50%; padding: 8px;">${
                  this.kr998?.description ?? " "
                }</td>
                <td style="border: 1px solid #000; padding: 8px;">${
                  this.kr998?.hours ?? ""
                }</td>
              </tr>
            </table>
            <table style="width: 100%; border-collapse: collapse; margin-top: 20px;">
              <tr style="background-color: #e9ecef; text-align: center;">
                <td style="border: 1px solid #000; padding: 2px;">Email</td>
                <td style="border: 1px solid #000; padding: 2px;">NAME</td>
                <td style="border: 1px solid #000; padding: 2px;">MGCCC</td>
                <td style="border: 1px solid #000; padding: 2px;">SIGNATURE</td>
                <td style="border: 1px solid #000; padding: 2px;">UNIT</td>
              </tr>
              ${userRows}
            </table>
            <table style="width: 100%; border-collapse: collapse; margin-top: 20px;">
              <tr style="background-color: #e9ecef; text-align: center;">
                <td colspan="5" style="border: 1px solid #000; padding: 8px;">KR898 Plant Protection Attendance</td>
              </tr>
              <tr style="background-color: #e9ecef; text-align: center;">
                <td style="border: 1px solid #000; padding: 2px;">Email</td>
                <td style="border: 1px solid #000; padding: 2px;">NAME</td>
                <td style="border: 1px solid #000; padding: 2px;">MGCCC</td>
                <td style="border: 1px solid #000; padding: 2px;">SIGNATURE</td>
                <td style="border: 1px solid #000; padding: 2px;">UNIT</td>
              </tr>
              ${instructorRows}
            </table>
          </div>
        </main>
        <script>
          window.onload = function() {
            window.print();
          }
        </script>
      </body>
    </html>
  `);
      printWindow.document.close();
    } else {
      console.error("Could not open print window");
    }
  }

  getTrainingTypeName(trainingTypeId: number): string {
    return TrainingType[trainingTypeId];
  }

  getLastPostedCrew(picklistValues: IPicklistValuesData[]): string {
    let name: string = this.getValueForField(picklistValues, this.crewFieldId);
    return name;
  }

  getLastPostedCategory(picklistValues: IPicklistValuesData[]): string {
    let name: string = this.getValueForField(
      picklistValues,
      this.categoryFieldId
    );
    return name;
  }

  getLastPostedUnit(picklistValues: IPicklistValuesData[]): string {
    let name: string = this.getValueForField(picklistValues, this.unitFieldId);
    return name;
  }
}
